import { Component, inject } from '@angular/core';
import { UnauthPageIntroComponent } from '../../components/unauth-page-intro/unauth-page-intro.component';
import { UnauthenticatedPageComponent } from '../../components/unauthenticated-page/unauthenticated-page.component';
import { UnauthenticatedForwardNavService } from '../../services/unauthenticated-forward-nav.service';

@Component({
  selector: 'app-register-interest-thanks',
  standalone: true,
  imports: [UnauthenticatedPageComponent, UnauthPageIntroComponent],
  templateUrl: './register-interest-thanks.component.html',
  styleUrls: ['../about-project/about-project.component.css'],
})
export class RegisterInterestThanksComponent {
  readonly unauthNav = inject(UnauthenticatedForwardNavService);
  readonly pageTitle = 'Thank you';
}
